import { UblInvoice } from '../../data/models'

export const invoiceTypeCodeToLocalizationKey: Record<
  UblInvoice['InvoiceTypeCode']['Value'],
  string
> = {
  71: 'Request_for_payment',
  80: 'Debit_note_related_to_goods_or_services',
  81: 'Credit_note_related_to_goods_or_services',
  82: 'Metered_services_invoice',
  83: 'Credit_note_related_to_financial_adjustments',
  84: 'Debit_note_related_to_financial_adjustments',
  102: 'Tax_notification',
  218: 'Invoicing_data_sheet',
  219: 'Direct_payment_valuation',
  326: 'Partial_invoice',
  331: 'Commercial_invoice_which_includes_a_packing_list',
  380: 'Commercial_invoice',
  381: 'Credit_note',
  382: 'Commission_note',
  383: 'Debit_note',
  384: 'Corrected_invoice',
  386: 'Prepayment_invoice',
  388: 'Tax_invoice',
  389: 'Self-billed_invoice',
  393: 'Factored_invoice',
  395: 'Consignment_invoice',
  396: 'Factored_credit_note',
  532: "Forwarder's_credit_note",
  553: "Forwarder's_invoice_discrepancy_report",
  575: "Insurer's_invoice",
  623: "Forwarder's_invoice",
  780: 'Freight_invoice',
  817: 'Claim_notification',
  870: 'Consular_invoice',
  875: 'Partial_construction_invoice',
  876: 'Partial_final_construction_invoice',
  877: 'Final_construction_invoice',
}
export const getInvoiceTypeCodeString = (
  option: UblInvoice['InvoiceTypeCode']['Value'] | undefined,
) => {
  const localizationKey = option
    ? invoiceTypeCodeToLocalizationKey[option]
    : undefined
  return localizationKey
}
